module.exports = __webpack_public_path__ + "static/media/pt-blood.1bff34b7.png";